import React from 'react';

/**
 * Turn `*x*` markers in a short string into <em>x</em>. Designed only for
 * inline editorial accents in highlights (pill values, undertitle, helpNote
 * rows). Not a markdown parser — pair markers only, no escaping.
 */
export function parseEm(text: string): React.ReactNode {
  const parts = text.split('*');
  return parts.map((part, i) =>
    i % 2 === 1 ? <em key={i}>{part}</em> : <React.Fragment key={i}>{part}</React.Fragment>,
  );
}
